import { useAppSelector } from 'appState/store'
import styled from 'styled-components'

export const ClaimsTableItemsDisplay = () => {
  const { totalItems, itemsPerPage } = useAppSelector((state) => {
    return state.claims.claimsTable
  })

  return (
    <>
      <Div>
        Displaying {itemsPerPage} of {totalItems} claims
      </Div>
    </>
  )
}

const Div = styled.div`
  padding-right: 1.25rem !important;
  padding: 0.4375rem 0;
  margin-right: 0.75rem;
`
